import { useTranslation } from "react-i18next";

import { useDealLock } from "../../../stores/approvalStore";

// Persistent banner shown at the top of the deal when the current user cannot
// edit it because of the VLA In-Use lock (OR-20985). Renders for:
//   held-by-other — another analyst holds the lock (names the holder)
//   error         — the lock couldn't be acquired (fail-safe read-only)
// Nothing renders while acquiring or when the current user holds the lock.
function DealLockBanner() {
  const { t } = useTranslation();
  const lock = useDealLock();

  if (lock.phase !== "held-by-other" && lock.phase !== "error") {
    return null;
  }

  const message =
    lock.phase === "held-by-other"
      ? // Prefer the holder's display name; fall back to a generic label rather
        // than leaking the raw SSO id (lockedByUserName is often null from the BFF).
        t("lock.heldByOther", { holder: lock.holderName ?? t("lock.holderFallback") })
      : t("lock.unavailable");

  return (
    // role="status" (polite) rather than "alert" (assertive): the banner is a
    // persistent read-only notice shown on load, not an urgent interruption.
    <div role="status" className="bg-warning text-warning-foreground mb-2 rounded-md px-3 py-1 text-center text-xs">
      {message}
    </div>
  );
}

export default DealLockBanner;
